(function ($, Drupal, once) {
  Drupal.behaviors.histallay_allergy = {
    attach(context) {
      const mainSymptoms = context.querySelectorAll('.allergies-homepage-listing .fieldgroup input');
      const otherSymptoms = context.querySelector('.allergies-homepage-listing select');

      // Change Main symptoms value to All if Other symptoms filter value is changed
      otherSymptoms?.addEventListener('change', (e) => {
        if (e.target.value !== 'All') {
          mainSymptoms[0].checked = true;
        }
      });

      const slider = context.querySelectorAll('.allergies-homepage-listing .item-list ul');

      $(slider).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        speed: 400,
        arrows: true,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              autoplay: true,
              speed: 400
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              autoplay: true,
              speed: 400
            },
          },
        ],
      });

      // Implementing navigation of slides using mouse scroll
      // $(slider).on('wheel', (function (e) {
      //   e.preventDefault();
      //   if (e.originalEvent.deltaY < 0) {
      //     $(this).slick('slickPrev');
      //   } else {
      //     $(this).slick('slickNext');
      //   }
      // }));

      // Implementing navigation of slides using keyboard
      $(document).on('keydown', function (e) {
        // Check for left arrow key
        if (e.key === 'ArrowLeft') {
          $(slider).slick('slickPrev');
        }
        // Check for right arrow key
        if (e.key === 'ArrowRight') {
          $(slider).slick('slickNext');
        }
      });

      const legend = context.querySelectorAll('.other-symptoms-wrapper legend');
      const doneBtn = context.querySelectorAll('.other-symptoms-wrapper > .btn-done');
      const lastOption = context.querySelectorAll('.other-symptoms-wrapper .form-checkboxes label:last-child');

      $(doneBtn).clone(true).insertAfter(lastOption);

      $(legend).on('click.once', function (e) {
        $(this).closest('fieldset').find('.form-checkboxes').slideToggle();
        $(this).toggleClass('open');
      });

      $('.other-symptoms-wrapper .fieldgroup').on('click.once', '.btn-done', function (e) {
        e.preventDefault();
        $('.allergies-homepage-listing .form-actions input').trigger('click');
      });

      var currTopPositionOfbigSphere, currTopPositionOfsmallSphere, currTopOffsetView, isAnimate, allergiesListingTopOffset, viewHeaderTopOffset;

      function allergiesViewVariables() {
        if ($(".allergies-homepage-listing").length) {
          currTopPositionOfbigSphere = $(".allergies-homepage-listing .view-filters .bg-sphere-big", context).position().top;
          currTopPositionOfsmallSphere = $(".allergies-homepage-listing .view-filters .bg-sphere-small", context).position().top;
          currTopOffsetView = $('.allergies-homepage-listing', context).offset().top;
          allergiesListingTopOffset = $('.allergies-homepage-listing', context).offset().top + 50;
          viewHeaderTopOffset = $('.allergies-homepage-listing .view-header-wrapper', context).offset().top - 50;
          isAnimate = false;
        }
      }

      // $(document, context).once('histallay_allergy').each(function () {
      // $(once('histallay_allergy', document, context)).each(function () {
      //   allergiesViewVariables();
      // });
      once('histallay_allergy', document, context).forEach(function(el) {
        allergiesViewVariables();
      });

      // $(once('histallay_allergy_ajax',document, context)).ajaxSuccess(function () {

      //   isAnimate = false;

      //   if (!$('body').hasClass('user-logged-in')) {
      //     // Focus on view result without animation
      //     setTimeout(function () {
      //       $('html, body').animate({
      //         scrollTop: $('.allergies-homepage-listing .view-content', context).offset().top - 100
      //       }, 500);
      //     });
      //   }
      // });

      once('histallay_allergy_ajax', document, context).forEach(function(el) {
        $(document).ajaxSuccess(function() {
          isAnimate = false;

          if (!$('body').hasClass('user-logged-in')) {
            setTimeout(function() {
              $('html, body').animate({
                scrollTop: $('.allergies-homepage-listing .view-content', context).offset().top - 100
              }, 500);
            });
          }
        });
      });

      // Global variables
      var currentScroll = $(window).scrollTop();
      var widnowHeightWithoutScroll = $(window).height() - currentScroll;
      var ytlBigSphere = 100;
      var rotateLength = 400;
      $(window).on('scroll', function (event) {
        currentScroll = $(window).scrollTop();
        if (window.innerWidth >= 1366) {

          if (currentScroll > (allergiesListingTopOffset - 500)) {
            // Circle rotate and sticky animations
            var newTopPosition = (ytlBigSphere * (currentScroll / widnowHeightWithoutScroll));
            $(".allergies-homepage-listing .view-filters .bg-sphere-big", context).css({ top: currTopPositionOfbigSphere + newTopPosition + 'px' });

            var newTopPosition = (ytlBigSphere * (currentScroll / widnowHeightWithoutScroll));
            $(".allergies-homepage-listing .view-filters .bg-sphere-small", context).css({ top: currTopPositionOfsmallSphere + newTopPosition + 'px' });

            var newRotation = (rotateLength * (currentScroll / widnowHeightWithoutScroll));
            $(".allergies-homepage-listing .view-filters .bg-sphere-big", context).css('transform', 'rotate(-' + newRotation + 'deg)');

            var newRotation = (rotateLength * (currentScroll / widnowHeightWithoutScroll));
            $(".allergies-homepage-listing .view-filters .bg-sphere-small", context).css('transform', 'rotate(' + newRotation + 'deg)');
          }
        }
      });
    },
  };
})(jQuery, Drupal, once);
